import { render, staticRenderFns } from "./TiktokCallback.vue?vue&type=template&id=0153129c&scoped=true"
import script from "./TiktokCallback.vue?vue&type=script&lang=js"
export * from "./TiktokCallback.vue?vue&type=script&lang=js"
import style0 from "./TiktokCallback.vue?vue&type=style&index=0&id=0153129c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0153129c",
  null
  
)

export default component.exports